import { render, staticRenderFns } from "./smBurgerMenu.vue?vue&type=template&id=2cbaff48&scoped=true&"
import script from "./smBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./smBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./smBurgerMenu.vue?vue&type=style&index=0&id=2cbaff48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbaff48",
  null
  
)

export default component.exports